import { FC, ReactNode } from "react";
import { useBreakpoints } from "@jobber/hooks/useBreakpoints";
import { Content } from "@jobber/components/Content";

type SidePanelProps = {
    readonly children: ReactNode | ReactNode[],
};

const SidePanel: FC<SidePanelProps> = ({
    children,
}) => {
    let breakpoints = useBreakpoints();

    return (
        <div
            style={{
                maxWidth: breakpoints.mediumAndUp ? "40%" : "100%",
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
                padding: "20px",
                gap: "5px",
                borderRadius: "8px",
                backgroundColor: "var(--color-surface--background--subtle)",
            }}
        >
            <Content type={"div"} spacing={"base"}>
                {children}
            </Content>
        </div>
    );
};

export default SidePanel;